import { render } from "./AppAvatar.vue?vue&type=template&id=52d3742f&scoped=true"
import script from "./AppAvatar.vue?vue&type=script&lang=js"
export * from "./AppAvatar.vue?vue&type=script&lang=js"

import "./AppAvatar.vue?vue&type=style&index=0&id=52d3742f&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d3742f"]])

export default __exports__